import axios from 'axios';
import { API_ENDPOINTS } from '@src/constants/api';

export interface AuthUser {
  id: number;
  role?: 'user' | 'admin';
  email: string;
  first_name?: string;
  last_name?: string;
}

interface CurrentUserResponse {
  user: AuthUser | null;
}

interface LoginResponse {
  message: string;
  user: Pick<AuthUser, 'id' | 'email' | 'role'>;
}

interface LogoutResponse {
  message: string;
}

export const AuthService = {
  async getMe(): Promise<CurrentUserResponse> {
    const response = await axios.get<CurrentUserResponse>(`${API_ENDPOINTS.AUTH}/me`, {
      withCredentials: true,
    });
    return response.data;
  },

  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await axios.post<LoginResponse>(
      `${API_ENDPOINTS.AUTH}/login`,
      { email, password },
      { withCredentials: true },
    );
    return response.data;
  },

  async logout(): Promise<LogoutResponse> {
    const response = await axios.post<LogoutResponse>(
      `${API_ENDPOINTS.AUTH}/logout`,
      {},
      { withCredentials: true, timeout: 10_000 },
    );
    return response.data;
  },
};
